//商品テンプレート 必須チェック


function checkfunction() {
  var check = document.getElementById("agree");
  var alert = document.getElementById("requiments-alert");
  var message = $(".Product__Info button[type='submit']");

  if (message && message.length >= 2) {
    message = message[1];
  } else {
    message = message[0];
  }

  if (!message) {
    message = document.getElementById("multi_variant");
  }
  //messageのテキストがSOLD OUTの場合は無効
  if (message.textContent !== "SOLD OUT") {
    if (check.checked == true) {
      message.disabled = false;
      message.classList.remove("disabled")
      alert.style.display = "none";
    } else {
      alert.style.display = "block";
      message.classList.add("disabled")
      message.disabled = true;
    }
  }
}

// ページ読み込み時に実行
$(document).ready(function() {
  checkfunction();
});

var scrollAlert = document.getElementById("requiments-scroll");
const textArea = document.querySelector(".requiments-inner");
// textArea.addEventListener("scroll", 実行したい処理(イベントハンドラ));
var obj = document.getElementById("agree");
var result = obj.disabled;
// const label = document.querySelector("label");
console.log(textArea.scrollHeight);
 if ( textArea.scrollHeight < 250) {
    obj.disabled = false;
    scrollAlert.style.display = "none";
};
textArea.addEventListener("scroll", func = () => {
  var scrolltop = Math.abs(textArea.scrollHeight - textArea.clientHeight - textArea.scrollTop);
  if (scrolltop < 35) {
    obj.disabled = false;
    scrollAlert.style.display = "none";
  };

});



document.querySelector(".requimentsform").onclick = function () {
  if (obj.disabled == true) {
    scrollAlert.style.display = "block";
  };
};




function getCheckboxValue(agree){
  //チェック状態を取得する
  var obj = document.getElementById("agree");
  var result = obj.checked;
  var alert = document.getElementById("requiments-alert");
  var scrollAlert = document.getElementById("requiments-scroll");

  // Alertで表示する
  if(result){
    alert.style.display = "none";
    scrollAlert.style.display = "none";
  }else{
    alert.style.display = "block";
    scrollAlert.style.display = "block";
  }
}

